import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
})
export default class JunkItHeaderComponents extends Vue {
  @Prop() public step!: number;
  public displayBG: boolean = true;

  onResize() {
    this.displayBG = window.innerWidth > 960;
  }

  public created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
  get fullAddress() {
    if(!this.$store.getters.country[0]){
      return
    }
    return `${this.$store.getters.address} ${this.$store.getters.city} ${this.$store.getters.stateCountry.toUpperCase()} ${this.$store.getters.postcode} ${this.$store.getters.country [0].toUpperCase() + this.$store.getters.country.slice(1)}`
  }
}
